export default __webpack_public_path__ + "static/RallyPgHeaderImg-25fdfb512ac8b2dde6046988b5d43c2e.jpg";